import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 overflow-hidden mb-16">
      <div className="absolute inset-0">
        <img
          alt="Beautiful screen door installation on modern home exterior"
          className="w-full h-full object-cover object-center"
          src="https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/be885a9c-3398-4818-84e8-99c265ecdebf_compressed_magnific_create-an-ultrarealistic-_xg565M8jfW.webp"
        />
        <div className="absolute inset-0 bg-black/25 z-[2]" />
        <div className="absolute inset-0 bg-black/60" />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="text-primary-500 text-xs font-bold uppercase tracking-[0.25em]">
          {t('finalCta.label')}
        </span>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white mt-3 leading-tight">
          {t('finalCta.title')}
        </h2>
        <p className="text-white/70 mt-5 text-lg leading-relaxed">
          {t('finalCta.description')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Link
            to="/contact"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-full text-base transition-colors cursor-pointer text-center"
          >
            {t('finalCta.quoteBtn')}
          </Link>
          <a
            href="tel:+16574338533"
            className="whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-black font-bold px-10 py-4 rounded-full text-base transition-colors cursor-pointer flex items-center justify-center gap-2 text-center"
          >
            <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
            {t('finalCta.callBtn')}
          </a>
        </div>
      </div>
    </section>
  );
}